<template>
  <div class="personal-center anim-fade-in-up">
    <div class="page-header">
      <el-button icon="el-icon-back" size="small" @click="$router.go(-1)">返回</el-button>
      <h2 class="page-title">个人中心</h2>
    </div>

    <div class="content-card">
      <div class="card-header-row">
        <span class="card-user-name">{{ userInfo.userName || userInfo.userId }}</span>
        <el-tag :type="isAdmin ? 'warning' : 'success'" size="small">{{ isAdmin ? '管理员' : '用户' }}</el-tag>
      </div>

      <div class="detail-grid">
        <div class="detail-item">
          <span class="detail-label">账号</span>
          <span class="detail-value">{{ userInfo.userId }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">用户名</span>
          <span class="detail-value">{{ userInfo.userName }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">密码</span>
          <span class="detail-value muted">********</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">手机号</span>
          <span class="detail-value" :class="{ muted: !userInfo.phone }">{{ userInfo.phone || '未填写' }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">邮箱</span>
          <span class="detail-value" :class="{ muted: !userInfo.email }">{{ userInfo.email || '未填写' }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">课题组</span>
          <span class="detail-value" :class="{ muted: !userInfo.researchGroup }">{{ userInfo.researchGroup || '未填写' }}</span>
        </div>
      </div>

      <div class="card-actions">
        <el-button type="primary" size="small" icon="el-icon-edit" @click="openEditProfile">编辑资料</el-button>
        <el-button size="small" icon="el-icon-lock" @click="openChangePassword">修改密码</el-button>
      </div>
    </div>

    <!-- 编辑资料对话框 -->
    <el-dialog :visible.sync="editDialogVisible" title="编辑资料" width="440px" append-to-body :close-on-click-modal="false">
      <el-form ref="editProfileForm" :model="editForm" label-width="90px">
        <el-form-item label="手机号"><el-input v-model="editForm.phone" placeholder="请输入手机号" /></el-form-item>
        <el-form-item label="邮箱"><el-input v-model="editForm.email" placeholder="请输入邮箱" /></el-form-item>
        <el-form-item label="所属课题组"><el-input v-model="editForm.researchGroup" placeholder="请输入所属课题组" /></el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEditProfile" :loading="submittingProfile">确定</el-button>
      </div>
    </el-dialog>

    <!-- 修改密码对话框 -->
    <el-dialog :visible.sync="pwdDialogVisible" title="修改密码" width="440px" append-to-body :close-on-click-modal="false">
      <el-form ref="pwdFormRef" :model="pwdForm" :rules="pwdRules" label-width="100px">
        <el-form-item label="旧密码" prop="oldPassword"><el-input v-model="pwdForm.oldPassword" type="password" show-password placeholder="请输入旧密码" /></el-form-item>
        <el-form-item label="新密码" prop="newPassword"><el-input v-model="pwdForm.newPassword" type="password" show-password placeholder="请输入新密码" /></el-form-item>
        <el-form-item label="确认新密码" prop="confirmPassword"><el-input v-model="pwdForm.confirmPassword" type="password" show-password placeholder="请再次输入新密码" /></el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="pwdDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitChangePassword" :loading="pwdSubmitting">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<style scoped>
.page-header { display: flex; align-items: center; gap: 14px; margin-bottom: 24px; }
.page-title { font-family: var(--font-display); font-size: 1.5rem; font-weight: 500; color: var(--text-primary); margin: 0; letter-spacing: 0.04em; }

.content-card {
  background: var(--bg-surface); border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg); box-shadow: var(--shadow-card);
  padding: 28px; max-width: 900px; margin: 0 auto;
}

.card-header-row {
  display: flex; align-items: center; gap: 12px;
  margin-bottom: 22px; padding-bottom: 18px;
  border-bottom: 1px solid var(--border-subtle);
}
.card-user-name { font-family: var(--font-display); font-size: 1.25rem; font-weight: 600; color: var(--text-primary); letter-spacing: 0.03em; }

.detail-grid {
  display: grid; grid-template-columns: 1fr 1fr;
  border: 1px solid var(--border-subtle); border-radius: var(--radius-sm); overflow: hidden; margin-bottom: 22px;
}
.detail-item {
  display: flex; align-items: center; padding: 14px 18px;
  border-bottom: 1px solid var(--border-subtle); border-right: 1px solid var(--border-subtle);
}
.detail-item:nth-child(even) { border-right: none; }
.detail-item:nth-last-child(-n+2) { border-bottom: none; }
.detail-label { font-size: 0.82rem; color: var(--text-muted); min-width: 80px; flex-shrink: 0; font-weight: 500; }
.detail-value { font-size: 0.88rem; color: var(--text-primary); font-weight: 500; }
.detail-value.muted { color: var(--text-muted); font-weight: 400; }

.card-actions { display: flex; gap: 10px; }

@media screen and (max-width: 600px) {
  .detail-grid { grid-template-columns: 1fr; }
  .detail-item { border-right: none; }
  .detail-item:nth-last-child(-n+2) { border-bottom: 1px solid var(--border-subtle); }
  .detail-item:last-child { border-bottom: none; }
}
</style>

<script>
export default {
  data() {
    const validateConfirm = (rule, value, callback) => {
      if (value !== this.pwdForm.newPassword) { callback(new Error('两次输入不一致')); } else { callback(); }
    };
    const validateNewPwd = (rule, value, callback) => {
      if (value && value === this.pwdForm.oldPassword) { callback(new Error('新密码不能与原密码相同')); } else { callback(); }
    };
    return {
      isAdmin: false,
      userInfo: { userId: '', userName: '', phone: '', email: '', researchGroup: '' },
      editDialogVisible: false, submittingProfile: false,
      editForm: { phone: '', email: '', researchGroup: '' },
      pwdDialogVisible: false, pwdSubmitting: false,
      pwdForm: { oldPassword: '', newPassword: '', confirmPassword: '' },
      pwdRules: {
        oldPassword: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
        newPassword: [{ required: true, message: '请输入新密码', trigger: 'blur' }, { validator: validateNewPwd, trigger: 'blur' }],
        confirmPassword: [{ required: true, message: '请确认新密码', trigger: 'blur' }, { validator: validateConfirm, trigger: 'blur' }]
      }
    }
  },
  created() { this.fetchUserInfo(); },
  methods: {
    async fetchUserInfo() {
      try {
        let resp = await this.$axios.get('/user/info');
        if (resp.data.code !== 0) { resp = await this.$axios.get('/adm/info'); }
        if (resp.data.code !== 0) return;
        const d = resp.data.data;
        this.isAdmin = d.role === '管理员';
        this.userInfo = { userId: d.userId || '', userName: d.userName || '', phone: d.phone || '', email: d.email || '', researchGroup: d.researchGroup || '' };
      } catch (e) { console.warn(e); }
    },
    openEditProfile() {
      this.editForm = { phone: this.userInfo.phone || '', email: this.userInfo.email || '', researchGroup: this.userInfo.researchGroup || '' };
      this.editDialogVisible = true;
      this.$nextTick(() => { if (this.$refs.editProfileForm) this.$refs.editProfileForm.clearValidate(); });
    },
    async submitEditProfile() {
      this.submittingProfile = true;
      try {
        const resp = await this.$axios.put('/user/updateProfile', this.editForm);
        if (resp.data.code === 0) { this.$message.success('资料更新成功'); this.editDialogVisible = false; this.fetchUserInfo(); }
        else { this.$message.error(resp.data.msg || '更新失败'); }
      } catch (e) { this.$message.error('更新失败'); } finally { this.submittingProfile = false; }
    },
    openChangePassword() {
      this.pwdForm = { oldPassword: '', newPassword: '', confirmPassword: '' };
      this.pwdDialogVisible = true;
      this.$nextTick(() => { if (this.$refs.pwdFormRef) this.$refs.pwdFormRef.clearValidate(); });
    },
    async submitChangePassword() {
      const valid = await this.$refs.pwdFormRef.validate().catch(() => false);
      if (!valid) return;
      this.pwdSubmitting = true;
      try {
        const resp = await this.$axios.put('/user/changePassword', this.pwdForm);
        if (resp.data.code === 0) { this.pwdDialogVisible = false; this.$message.success('密码修改成功，请重新登录');
          this.$axios.post('/api/session/destroy').finally(() => { this.$router.push('/login'); }); }
        else { this.$message.error(resp.data.msg || '修改失败'); }
      } catch (e) { this.$message.error('修改密码失败'); } finally { this.pwdSubmitting = false; }
    }
  }
}
</script>
